import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { getRuntimeConfig } from './config/runtime'
import { isAdminUser, useUserStore } from './stores/user-store'
import { supabase } from './services/supabase'

const app = createApp(App)

app.use(stores)

const userStore = useUserStore()

userStore.fetchSession().then(() => {
  supabase.auth.onAuthStateChange((event, session) => {
    const user = session?.user
    if (user && !isAdminUser(user)) {
      supabase.auth.signOut()
      userStore.session = null
      userStore.user = null
      userStore.email = ''
      router.push({ name: 'login' })
      return
    }

    userStore.session = session
    userStore.user = user || null
    if (user) {
      userStore.email = user.email || ''
    }
  })

  app.use(router)
  app.use(i18n)
  app.use(createVuestic({ config: vuesticGlobalConfig }))

  const runtimeConfig = getRuntimeConfig()

  if (runtimeConfig.gtmEnabled && runtimeConfig.gtmKey) {
    app.use(
      createGtm({
        id: runtimeConfig.gtmKey,
        debug: false,
        vueRouter: router,
      }),
    )
  }

  app.mount('#app')
})
